import { Dispatch, FC, SetStateAction } from "react";
import { Button } from "react-bootstrap";
import Table from "../../../common/Table";
import { rankScorersColumns, rankScorersColumnsMobile } from "../../../config/Tables/scorer";
import { ICategoryGroup } from "../../../helpers/interfaces/ranking";

interface IRankScorersTable {
    currentGroup: ICategoryGroup | undefined,
    expanded: boolean,
    setExpanded: Dispatch<SetStateAction<boolean>>
}

const RankScorersTable: FC<IRankScorersTable> = (
    { currentGroup, expanded, setExpanded }
) => {

    return currentGroup ? <>
        <h3 className='mb-4'>Classifica Marcatori</h3>
        <div className='rank_scorers_table'>
            <Table
                columns={[...rankScorersColumns]}
                id={`tab_rank_groups_${currentGroup.id}_scorers`}
                columnsMobile={[...rankScorersColumnsMobile]}
                data={
                    currentGroup && currentGroup.classificaMarcatori ?
                        (expanded ? currentGroup.classificaMarcatori : currentGroup.classificaMarcatori.slice(0, 15))
                        : []
                }
                emptyDataText="Nessun marcatore presente"
            />
            {currentGroup && currentGroup.classificaMarcatori && currentGroup.classificaMarcatori.length > 15 && !expanded && <div className="d-flex justify-content-center border border-top-0 p-0" id="rank-scorers-expand">
                <Button variant='link' onClick={() => setExpanded(true)}>Visualizza tutti i giocatori</Button>
            </div>}
        </div>
    </> : <></>
}

export default RankScorersTable;